import { CloneFilesDriveGroup } from '../models/CloneFilesDriveGroup'
import { FileCloneDriveGroup } from '../models/FileCloneDriveGroup'
import { CloneRepository } from '../repositories/CloneRepository'

export function CloneDataDriveCase(cloneRepository: CloneRepository) {
  return {
    async cloneDataDrive(
      data: CloneFilesDriveGroup,
      patientId: string
    ): Promise<FileCloneDriveGroup> {
      return await cloneRepository.cloneDataDrive(data, patientId)
    }
  }
}
